<template>
  <div class="homeSlider">
    <slick
      ref="slick"
      :options="slickOptions">
      <router-link :to="{path : item.path}" tag="a" v-for="(item, index) in data" :key="index">
        <div class="wrapper">
          <img :placeholder="item.url" :src="item.url" :blur="100" />
          <!-- <img :src="item.url" alt=""> -->
          <div class="description">
            <h2 class="subhead color-white">ADX ASIA</h2>
            <h6>{{item.description}}</h6>
          </div>
        </div>
      </router-link>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'adx-slider',
  props: {
    data: {
      required: true
    }
  },
  components: {
    'slick': Slick
  },
  data() {
    return {
      slickOptions: {
          slidesToShow: 1,
          autoplay: true,
          nextArrow: '<button type="button" style="' +
                  'bottom: 24px; width:32px; height:32px; position:absolute; right:5%;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
          prevArrow: '<button type="button" style="' +
                  'bottom: 24px; width:32px; height:32px; position:absolute; left: 5%;"' +
                  'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
          centerMode: true,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                arrows: true,
                centerMode: true,
                slidesToShow: 1
              }
            }
          ]
      },
    }
  },
  methods: {
      next() {
          this.$refs.slick.next()
      },

      prev() {
          this.$refs.slick.prev()
      },

  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
